import {ContentBlock, Icon} from "@gplibraries/react/components";
import {Link} from "react-router";
import {StringFormatter} from "@gplibraries/utils";

interface TmInfoBlockProps {
  tm: {
    name: string;
    phone?: string;
    email?: string;
  }
}

export default function TmInfoBlock({ tm }: TmInfoBlockProps) {

  return (
    <ContentBlock title={'Your TM'} icon={<Icon glyph={'person-fill'}/>}>
      <div className={'tm-info-block flex-col'}>

        <h3>{tm.name}</h3>

        {tm.phone &&
        <div className="flex-inline">
          <Link to={`tel:${tm.phone}`}>
            <Icon glyph={'telephone-fill'}/>
            {StringFormatter.phone(tm.phone)}
          </Link>
        </div>
        }

        {tm.email &&
        <div className="flex-inline">
          <Link to={`mailto:${tm.email}`}>
            <Icon glyph={'envelope-at-fill'}/>
            {tm.email.toLowerCase()}
          </Link>
        </div>
        }

      </div>
    </ContentBlock>
  );
}